export function appendCourierPathPoint(path, point) {
  const nextPath = Array.isArray(path) ? [...path] : []
  const lastPoint = nextPath[nextPath.length - 1]

  if (
    lastPoint &&
    lastPoint.lat === point.lat &&
    lastPoint.lng === point.lng
  ) {
    return nextPath
  }

  nextPath.push(point)
  return nextPath
}
